import './index.scss'
import {initApp, setActiveNav} from 'app/js/app'

const $toLagou = $('#toLagou')
setActiveNav()
let activeTabIdx = 0

$(() => {
	initApp()
	initialize()
})




function drawMap(map, point, marker, searchInfoWindow) {
	map.centerAndZoom(point, 14)
	map.addOverlay(marker)
	map.enableScrollWheelZoom()
	marker.setAnimation(BMAP_ANIMATION_BOUNCE)
	setTimeout(() => { //2秒后放大到14级
		map.addOverlay(marker)
		marker.setAnimation()
		// searchInfoWindow.open(marker);
		map.setZoom(16)
	}, 2000)
}

function initialize() {
	var map = new BMap.Map("map") // 创建地图实例
	// BD-09：环球贸易中心（GTC）— 北京市东城区北三环东路36号
	var point = new BMap.Point(116.41798, 39.96771)
	var marker = new BMap.Marker(point) // 创建标记
	// var img = '<img src="../img/baidu.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>'
	var content = '<div style="margin:0;line-height:20px;">' +
		'北京市东城区北三环东路36号<br/>' +
		'3号楼(E座) 8层 813室' +
		'</div>'
	//创建检索信息窗口对象
	var searchInfoWindow = null
	//searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
	//	title: "星城国际大厦大厦", //标题
	//	width: 290, //宽度
	//	height: 105, //高度
	//	enableAutoPan: true, //自动平移
	//	searchTypes: []
	//})
	drawMap(map, point, marker, searchInfoWindow)
	marker.addEventListener("click", function (e) {
		if (searchInfoWindow && typeof searchInfoWindow.open === 'function') {
			searchInfoWindow.open(marker)
		}
		marker.setAnimation()
	})
	map.addOverlay(marker)


	// var geoc = new BMap.Geocoder()
	// map.addEventListener("click", function (e) {
	//   geoc.getLocation(pt, function (rs) {
	//     console.log(rs, 'rs')
	//   })
	// })
}




// WEBPACK FOOTER //
// ./src/address/index.js